import React from "react";
import {ColumnsType} from "antd/es/table";
import {FIELD_TYPE, FORMAT_TIME, TT_PHIEU_KHO} from "types/enums";
import {ColumnProps} from "types/models";
import {formatDateToString, formatToCurrencyType} from "helper/common";
import {listTTPhieuKho} from "data/list";
import moment from "moment";

const {INPUT, SELECT, DATE, COMBO_BOX} = FIELD_TYPE;
const inputFields: any[] = [
  {
    type: INPUT,
    name: "id",
    label: "Mã phiếu",
  },
  {
    type: INPUT,
    name: "tieuDe",
    label: "Tiêu đề phiếu",
  },

  {
    type: COMBO_BOX,
    name: "khoId",
    label: "Kho kiểm kê",
  },
  {
    type: COMBO_BOX,
    name: "nguonThuocId",
    label: "Nguồn thuốc",
  },

  {
    type: COMBO_BOX,
    name: "tinhTrang",
    label: "Tình trạng",
    options: listTTPhieuKho,
  },
  {
    type: DATE,
    name: "ngayTaoTu",
    label: "Ngày tạo từ",
  },
  {
    type: DATE,
    name: "ngayTaoDen",
    label: "Ngày tạo đến",
  },
];
const allColumns: ColumnProps[] = [
  {
    key: "index",
    title: "STT",
    show: true,
    isResizable: true,
    dataIndex: "index",
    render(value, record, index) {
      return <>{index + 1}</>;
    },
    align: "center",
  },
  {
    key: "code",
    title: "Mã phiếu",
    align: "center",
    show: true,
    isResizable: true,
    dataIndex: "id",
  },
  {
    title: "Kho kiểm kê",
    key: "tenKho",
    show: true,
    isResizable: true,
    dataIndex: "tenKho",
  },
  {
    title: "Tiêu đề phiếu",
    key: "tieuDe",
    show: true,
    isResizable: true,
    dataIndex: "tieuDe",
  },
  {
    title: "Nguồn thuốc",
    key: "nguonThuoc",
    show: true,
    isResizable: true,
    dataIndex: "nguonThuoc",
  },
  {
    title: "Trạng thái phiếu",
    key: "tinhTrang",
    show: true,
    isResizable: true,
    dataIndex: "tinhTrang",
    render(value, record, index) {
      var tinhTrang;
      switch (value) {
        case TT_PHIEU_KHO.NHAP:
          return "Nháp";
        case TT_PHIEU_KHO.CHO_DUYET:
          return "Chờ duyệt";
        case TT_PHIEU_KHO.DA_DUYET:
          return "Đã duyệt";
        case TT_PHIEU_KHO.HOAN_THANH:
          return "Hoàn thành";
        case TT_PHIEU_KHO.HUY_PHIEU:
          return "Hủy";
        case TT_PHIEU_KHO.TU_CHOI:
          return "Từ chối";
        default:
          break;
      }
    },
  },
  {
    title: "Ngày kiểm kê",
    key: "createDate",
    show: true,
    isResizable: true,
    align: "center",
    dataIndex: "createDate",
    render(value, record, index) {
      return (
        <>
          {value ? formatDateToString(moment(value), FORMAT_TIME.dayFull) : ""}
        </>
      );
    },
  },

  {
    title: "Người lập phiếu",
    key: "createBy",
    show: true,
    isResizable: true,
    dataIndex: "createBy",
  },
  {
    title: "Người kiểm kê",
    key: "nguoiKiemKe",
    show: true,
    isResizable: true,
    dataIndex: "nguoiKiemKe",
  },

  {
    title: "Tổng giá trị",
    key: "tongGiaTri",
    show: true,
    isResizable: true,
    dataIndex: "tongGiaTri",
    render(value, record, index) {
      return formatToCurrencyType(value);
    },
    align: "right",
  },
  {
    title: "Ghi chú",
    key: "leftNumber",
    show: true,
    isResizable: true,
    dataIndex: "tonKho",
  },
];

export {allColumns, inputFields};
